import { ModeSettingEnum } from '@colonist/game-base-types';
import { isGameModeLockedForUser } from '../ui_utils/isGameModeLockedForUser.ts';
import { getItemInfoSubscribeAction } from './getItemInfoSubscribeAction.ts';
import { showRoomItemInfoDialog } from './showRoomItemInfoDialog.ts';
export function showGameModeInfoDialog(gameModeData) {
    showRoomItemInfoDialog({
        title: gameModeData.name,
        image: gameModeData.icon,
        bodyItems: getGameModeInfoBody(gameModeData.modeSetting),
        onSubscribe: getItemInfoSubscribeAction(isGameModeLockedForUser(gameModeData), ModeSettingEnum[gameModeData.modeSetting], 'gameMode')
    });
}
function getGameModeInfoBody(modeSetting) {
    switch(modeSetting){
        case ModeSettingEnum.Classic4P:
            return 'strings:colonistCommon.gameModes.classic4P.body';
        case ModeSettingEnum.TutorialClassic4P:
        case ModeSettingEnum.BeginnerModeClassic4P:
            return 'strings:colonistCommon.gameModes.classicTutorial4P.body';
        case ModeSettingEnum.Classic56P:
            return 'strings:colonistCommon.gameModes.classic56P.body';
        case ModeSettingEnum.Classic78P:
            return 'strings:colonistCommon.gameModes.classic78P.body';
        case ModeSettingEnum.Seafarers4P:
            return 'strings:colonistCommon.gameModes.seafarers4P.body';
        case ModeSettingEnum.Seafarers56P:
            return 'strings:colonistCommon.gameModes.seafarers56P.body';
        case ModeSettingEnum.CitiesAndKnights4P:
            return 'strings:colonistCommon.gameModes.citiesAndKnights4P.body';
        case ModeSettingEnum.CitiesAndKnights56P:
            return 'strings:colonistCommon.gameModes.citiesAndKnights56P.body';
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            return 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights4P.body';
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return 'strings:colonistCommon.gameModes.seafarersAndCitiesAndKnights56P.body';
        case ModeSettingEnum.ServerStressTestClassic4P:
            return 'strings:colonistCommon.gameModes.serverStressTestClassic4P.body';
        case ModeSettingEnum.ColonistRush4P:
            return 'strings:colonistCommon.gameModes.colonistRush.body';
    }
}
